module.exports = __webpack_public_path__ + "img/icon-bike.60607963.svg";